import ComposeViewState, { ComposeOperation } from '../store/schema/ComposeViewState';
import closeCompose from './closeCompose';
import composeStore from '../store/composeStore';
import discardCompose from './discardCompose';
import setIsSavingSpinnerShown from './setIsSavingSpinnerShown';
import trySaveMessage, { waitForActiveSaving } from './trySaveMessage';
import { action, select } from 'satcheljs/lib/legacy';
import { isViewStateDirty } from '../utils/viewStateUtils';
import blockOnNavigation from '../utils/blockOnNavigation';
import { isPublicFolderComposeViewState } from 'owa-mail-compose-store/lib/utils/createPublicFolderComposeViewState';

export interface TrySaveAndCloseComposeState {
    defaultViewState: ComposeViewState;
}

export default action('trySaveAndCloseCompose')(
    select<TrySaveAndCloseComposeState>({
        defaultViewState: () => composeStore.viewStates.get(composeStore.primaryComposeId),
    })(async function trySaveAndCloseCompose(
        viewState: ComposeViewState,
        state?: TrySaveAndCloseComposeState
    ): Promise<void> {
        if (!viewState) {
            viewState = state.defaultViewState;
        }

        if (viewState) {
            if (await blockOnNavigation(viewState)) {
                return;
            }

            //If it is a Post scenario, we want to discard compose on closing it
            if (isPublicFolderComposeViewState(viewState)) {
                discardCompose(viewState);
                return;
            }

            await waitForActiveSaving(viewState);

            if (isViewStateDirty(viewState)) {
                setIsSavingSpinnerShown(viewState, true /*isShown*/);
                return trySaveMessage(viewState, false /*isAutoSave*/, true /*rejectWhenFail*/)
                    .then(() => {
                        setIsSavingSpinnerShown(viewState, false /*isShown*/);
                        closeCompose(viewState);
                    })
                    .catch(() => {
                        setIsSavingSpinnerShown(viewState, false /*isShown*/);
                    });
            } else if (
                viewState.itemId &&
                viewState.operation != ComposeOperation.EditDraft &&
                !viewState.lastSaveTimeStamp
            ) {
                // item has upgraded (has itemId but doesn't have lastSaveTimeStamp) but item is not dirty in R/RA/F scenario, we should delete the draft
                discardCompose(viewState);
            } else {
                closeCompose(viewState);
            }
        }

        return Promise.resolve();
    })
);
